<div class="project-donators" *ngIf="donations.length > 0">
	<div class="row column">
		<h3>{{ 'projectdonators.headline' | translate }}</h3>
	</div>
	<div class="row" *ngFor="let donation of donations">
		<div class="donation">
			<span class="amount">{{ donation.amount | number: '1.0-0' }}{{currency}}</span>
			<p>
				<span class="from">{{ 'projectdonators.from' | translate: {name: donation.data.name? donation.data.name : textAnonynous, diff: donation.timediff, unit: getTimeTimeDiffText(donation.timediffUnit) } }}</span>
				<span class="message" *ngIf="donation.data.message">&bdquo;{{ donation.data.message }}&ldquo;</span>
			</p>
		</div>
	</div>
	<div class="row column text-center" *ngIf="donations.length < itemOverallCount">
		<a class="more" (click)="sliceDonations(itemsPerPage)">{{ 'projectdonators.more' | translate }}</a>
	</div>
</div>
